module.exports = __webpack_public_path__ + "img/icon_sectionClose-sp.65a156f.svg";